define.alias("ember-composable-helpers/helpers/has-next", "settings/helpers/has-next");